export default "__VITE_ASSET__f75be9dc__"